function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import React from "react";
import { ExclusiveRange, useInclusiveRange } from "../Range/index.js";
import useThrotledAsyncCallback from "../useThrotledAsyncCallback/index.js";
import useAnimationTimeoutEffect from "./useAnimationTimeoutEffect.js";
import useReducerWithChangeCallback from "../useReducerWithChangeCallback/index.js";
import useActionCreators from "../useActionCreators/index.js";
import useRenderRef from "../useRenderRef/index.js";
var HIGHER_SENSITIVITY_DELTA_RANGE = new ExclusiveRange(20, 100);
var actionTypes = {
  DRAG: 'DRAG',
  MOVE: 'MOVE',
  ADJUST: 'ADJUST',
  RESET_ANIMATION: 'RESET_ANIMATION',
  CONTROLLED_NAVIGATION_INDEX_UPDATE: 'CONTROLLED_NAVIGATION_INDEX_UPDATE'
};
var animationStates = {
  DRAG: 'DRAG',
  MOVE: 'MOVE',
  ADJUST: 'ADJUST',
  NONE: null
};
var actionCreators = {
  drag: function drag(offset, navigationIndexRange) {
    return {
      type: actionTypes.DRAG,
      offset: offset,
      navigationIndexRange: navigationIndexRange
    };
  },
  move: function move(offset, navigationIndexRange) {
    return {
      type: actionTypes.MOVE,
      offset: offset,
      navigationIndexRange: navigationIndexRange
    };
  },
  adjust: function adjust(navigationIndexRange) {
    return {
      type: actionTypes.ADJUST,
      navigationIndexRange: navigationIndexRange
    };
  },
  resetAnimation: function resetAnimation() {
    return {
      type: actionTypes.RESET_ANIMATION
    };
  },
  controlledNavigationIndexUpdate: function controlledNavigationIndexUpdate(nextNavigationIndex) {
    return {
      type: actionTypes.CONTROLLED_NAVIGATION_INDEX_UPDATE,
      nextNavigationIndex: nextNavigationIndex
    };
  }
};
var getInitialState = function getInitialState() {
  var initialIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    animationState: animationStates.NONE,
    visualNavigationOffset: initialIndex,
    committedNavigationIndex: initialIndex
  };
};
var getNextIndexFromOffsetBoundToNavigationRange = function getNextIndexFromOffsetBoundToNavigationRange(state, action) {
  return action.navigationIndexRange.restrict(state.committedNavigationIndex + action.offset);
};
var reducer = function reducer(state, action) {
  switch (action.type) {
    case actionTypes.CONTROLLED_NAVIGATION_INDEX_UPDATE:
      {
        var draggingState = {};
        if (state.animationState !== animationStates.DRAG) {
          draggingState = {
            visualNavigationOffset: action.nextNavigationIndex,
            animationState: animationStates.MOVE
          };
        }
        return _objectSpread(_objectSpread(_objectSpread({}, state), draggingState), {}, {
          committedNavigationIndex: action.nextNavigationIndex
        });
      }
    case actionTypes.RESET_ANIMATION:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          animationState: animationStates.NONE
        });
      }
    case actionTypes.DRAG:
      {
        var nextIndex = getNextIndexFromOffsetBoundToNavigationRange(state, action);
        return _objectSpread(_objectSpread({}, state), {}, {
          visualNavigationOffset: nextIndex,
          animationState: animationStates.DRAG
        });
      }
    case actionTypes.MOVE:
      {
        var _nextIndex = getNextIndexFromOffsetBoundToNavigationRange(state, action);
        if (_nextIndex === state.committedNavigationIndex) {
          return state;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          visualNavigationOffset: _nextIndex,
          committedNavigationIndex: _nextIndex,
          animationState: animationStates.MOVE
        });
      }
    case actionTypes.ADJUST:
      {
        var delta = state.visualNavigationOffset - state.committedNavigationIndex;
        var absDelta = Math.abs(delta);
        var newNavigationIndex;
        if (_includesInstanceProperty(HIGHER_SENSITIVITY_DELTA_RANGE).call(HIGHER_SENSITIVITY_DELTA_RANGE, absDelta * 100)) {
          newNavigationIndex = delta > 0 ? Math.ceil(state.visualNavigationOffset) : Math.floor(state.visualNavigationOffset);
        } else {
          newNavigationIndex = Math.round(state.visualNavigationOffset);
        }
        var finalNavigationIndex = action.navigationIndexRange.restrict(newNavigationIndex);
        return _objectSpread(_objectSpread({}, state), {}, {
          visualNavigationOffset: finalNavigationIndex,
          committedNavigationIndex: finalNavigationIndex,
          animationState: animationStates.ADJUST
        });
      }
    default:
      {
        return state;
      }
  }
};
var useNavigation = function useNavigation(props, _ref) {
  var totalSlidesCount = _ref.totalSlidesCount,
    visibleSlidesCount = _ref.visibleSlidesCount;
  var isControlled = React.useRef(typeof props.navigationIndex !== 'undefined');
  var initialState = isControlled.current ? getInitialState(props.navigationIndex) : getInitialState(props.navigationIndexDefaultValue);

  /**
   * Use a ref to call the onNavigationChange callback in `useEffect`. This is helpful to ensure the
   * effect always has the latest version of the callback, without triggering the effect every time
   * the callback changes.
   */
  var onNavigationIndexChangeRef = useRenderRef(props.onNavigationIndexChange);
  var onNavigationRangeChangeRef = useRenderRef(props.onNavigationRangeChange);
  var onStateChange = React.useCallback(function (currentState, nextState, action) {
    if (action.type === actionTypes.CONTROLLED_NAVIGATION_INDEX_UPDATE) {
      return;
    }
    if (nextState.committedNavigationIndex !== currentState.committedNavigationIndex) {
      onNavigationIndexChangeRef.current(nextState.committedNavigationIndex);
    }
  }, []);
  var _useReducerWithChange = useReducerWithChangeCallback(reducer, initialState, onStateChange),
    _useReducerWithChange2 = _slicedToArray(_useReducerWithChange, 2),
    state = _useReducerWithChange2[0],
    dispatch = _useReducerWithChange2[1];
  var actions = useActionCreators(actionCreators, dispatch);
  var visibleSlidesIndexRange = useInclusiveRange(state.committedNavigationIndex, state.committedNavigationIndex + Math.max(visibleSlidesCount - 1, 0));
  var pageSize = props.pagination === 'auto' ? visibleSlidesIndexRange.length : props.pagination;
  var navigationIndexRange = useInclusiveRange(0, totalSlidesCount - visibleSlidesCount);
  var adjust = React.useCallback(function () {
    actions.adjust(navigationIndexRange);
  }, [navigationIndexRange, actions.adjust]);
  var resetAnimation = useThrotledAsyncCallback(function () {
    actions.resetAnimation();
  }, [dispatch]);

  /**
   * Side-effects
   */

  useAnimationTimeoutEffect(state.animationState, resetAnimation);
  var adjustRef = useRenderRef(adjust);
  React.useEffect(function () {
    onNavigationRangeChangeRef.current(navigationIndexRange);
    adjustRef.current();
  }, [navigationIndexRange]);
  if (state.committedNavigationIndex !== props.navigationIndex && isControlled.current) {
    actions.controlledNavigationIndexUpdate(props.navigationIndex);
  }
  return React.useMemo(function () {
    var move = function move(offset) {
      actions.move(offset, navigationIndexRange);
    };
    var moveLeft = function moveLeft() {
      move(-pageSize);
    };
    var moveRight = function moveRight() {
      move(pageSize);
    };
    var drag = function drag(offset) {
      actions.drag(offset, navigationIndexRange);
    };
    var canMove = function canMove(offset) {
      var nextIndex = state.committedNavigationIndex + offset;
      return _includesInstanceProperty(navigationIndexRange).call(navigationIndexRange, nextIndex);
    };
    return {
      // actions
      move: move,
      moveLeft: moveLeft,
      moveRight: moveRight,
      drag: drag,
      adjust: adjust,
      resetAnimation: resetAnimation,
      // state
      visualNavigationOffset: state.visualNavigationOffset,
      committedNavigationIndex: state.committedNavigationIndex,
      animationState: state.animationState,
      visibleSlidesIndexRange: visibleSlidesIndexRange,
      navigationIndexRange: navigationIndexRange,
      // selectors
      canMove: canMove
    };
  }, [actions, state, adjust, resetAnimation, pageSize, navigationIndexRange, visibleSlidesIndexRange]);
};
export default useNavigation;